import { slick } from "@accessible360/accessible-slick";
class RelatedCarousel {
    constructor(element) {
        this.el = element;
        this.init();
    }

    init() {
        if (window.matchMedia("(max-width: 48em)").matches) {
            this.createCarousel();
        }
    }

    createCarousel() {
        const props = {
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
        };

        let carousel = $(this.el).slick(props);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const carousels = document.querySelectorAll(
        "[data-carousel='related-events']",
    );
    carousels.forEach((element) => {
        new RelatedCarousel(element);
    });
});

export default RelatedCarousel;
